import styles from '@styles/screens/StartDemoScreen.module.css'
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/OrangeQontact.svg';
import { VerticalContainer } from './General/Containers';
import designSystem from '@styles/designSystem';

export const OrangeQontactLogo: React.FC = () => {
    return (
        <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            overflow: 'hidden',
        }}>
            <QontactTextSVG
                style={{ 
                    height: '100%',
                    width: 'auto',
                    fill: designSystem.colorMainAction,
                    marginLeft: '-3px'
                }}
            />
        </div>
    )
}